import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "reportnavmenu",
  "aria-labelledby": "reportmenulabel",
  class: "report-links"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { id: "reportmenulabel" }, "Report menu", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "link-inner d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Incident details")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "link-inner d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", null, "History")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "link-inner d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Responses")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "link-inner d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Cover Moves")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "link-inner d-flex justify-content-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Notifications", -1)
const _hoisted_13 = { class: "link-inner d-flex justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Messages", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NotificationTag = _resolveComponent("NotificationTag")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["report-links__button d-flex justify-content-between align-items-center", { open: _ctx.isOpen }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
    }, [
      _hoisted_2,
      _createVNode(_component_font_awesome_icon, {
        icon: "chevron-down",
        class: "report-links__button__icon"
      })
    ], 2),
    _createElementVNode("ol", {
      class: _normalizeClass(["report-links__links", { open: _ctx.isOpen }])
    }, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["report-links__link d-flex justify-content-between align-items-center", { active: _ctx.activeLink === _ctx.SECTION.DETAILS }]),
          href: "#details",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick(_ctx.SECTION.DETAILS)))
        }, _hoisted_4, 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["report-links__link d-flex justify-content-between align-items-center", { active: _ctx.activeLink === _ctx.SECTION.HISTORY }]),
          href: "#history",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick(_ctx.SECTION.HISTORY)))
        }, _hoisted_6, 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["report-links__link d-flex justify-content-between align-items-center", { active: _ctx.activeLink === _ctx.SECTION.RESPONSES }]),
          href: "#responses",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClick(_ctx.SECTION.RESPONSES)))
        }, _hoisted_8, 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["report-links__link d-flex justify-content-between align-items-center", { active: _ctx.activeLink === _ctx.SECTION.COVER }]),
          href: "#cover",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClick(_ctx.SECTION.COVER)))
        }, _hoisted_10, 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["report-links__link d-flex justify-content-between align-items-center", { active: _ctx.activeLink === _ctx.SECTION.NOTIFICATIONS }]),
          href: "#notifications",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleClick(_ctx.SECTION.NOTIFICATIONS)))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            (_ctx.reportStore.getUnreadNotificationCount > 0)
              ? (_openBlock(), _createBlock(_component_NotificationTag, {
                  key: 0,
                  value: _ctx.reportStore.getUnreadNotificationCount.toString(),
                  class: "new",
                  type: _ctx.NOTIFICATIONTYPES.GREEN
                }, null, 8, ["value", "type"]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["report-links__link d-flex justify-content-between align-items-center", { active: _ctx.activeLink === _ctx.SECTION.MESSAGES }]),
          href: "#messages",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleClick(_ctx.SECTION.MESSAGES)))
        }, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            (_ctx.reportStore.getUnreadMessageCount > 0)
              ? (_openBlock(), _createBlock(_component_NotificationTag, {
                  key: 0,
                  value: _ctx.reportStore.getUnreadMessageCount?.toString(),
                  class: "new",
                  type: _ctx.NOTIFICATIONTYPES.GREEN
                }, null, 8, ["value", "type"]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ], 2)
  ]))
}